import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "../Config.jsx";

import Localization from "../Localization.jsx"

import RootPage from "../pages/RootPage.jsx"
import StageViewerBar from "../views/stage/StageViewerBar.jsx"
import CreateStageDialog from "../views/stage/CreateStageDialog.jsx"
import EditStageDialog from "../views/stage/EditStageDialog.jsx"
import StageListView from "../views/stage/StageListView.jsx"
import StageDetailView from "../views/stage/StageDetailView.jsx"
import CreateElementDialog from "../views/stage/PlaybackElement/CreateElementDialog.jsx"
import EditElementDialog from "../views/stage/PlaybackElement/EditElementDialog.jsx"
import StagePicker from "../views/StagePicker.jsx"
import FilePicker from "../views/FilePicker.jsx"

import {
  Grid,
} from '@material-ui/core';

class StageViewerPage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      targetStageData: {},
      stageList: [],
      selectedStageID: "",
      selectedStage: null,
      maxHeight: 0,
      filePickerProps: {},
      trashFileIdList: [],
      aiGenerateEnabled: false,
      aiGenerateQuotaTotal: 0,
    };
    autoBind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.fetchAI360PhotoQuota();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  fetchAI360PhotoQuota() {
    const userId = this.props.root.getMyUserId();
    if (!userId) {
      this.setState({ aiGenerateEnabled: false, aiGenerateQuotaTotal: 0 });
      this.state.aiGenerateEnabled = false;
      this.state.aiGenerateQuotaTotal = 0;
      return;
    }
    this.props.root.refs.API.request(
      "get_ai_360_photo_quota",
      { user_id: userId },
      this.getAI360PhotoQuotaOK,
      this.getAI360PhotoQuotaFailed
    );
  }

  getAI360PhotoQuotaOK(res) {
    const result = (res && res.body && res.body['result']) ? res.body['result'] : {};
    const modelEnabled = parseInt(result['AI_360_photo_model'] || 0) === 1;
    const schoolQuota = parseInt(result['AI_360_photo_quotas_school'] || 0);
    const userQuota = parseInt(result['AI_360_photo_quotas_user'] || 0);
    const totalQuota = schoolQuota + userQuota;
    const canGenerate = modelEnabled && (schoolQuota > 0 || userQuota > 0);
    this.setState({ aiGenerateEnabled: canGenerate, aiGenerateQuotaTotal: totalQuota });
    this.state.aiGenerateEnabled = canGenerate;
    this.state.aiGenerateQuotaTotal = totalQuota;
  }

  getAI360PhotoQuotaFailed(err) {
    console.log("get ai 360 photo quota failed " + err);
    this.setState({ aiGenerateEnabled: false, aiGenerateQuotaTotal: 0 });
    this.state.aiGenerateEnabled = false;
    this.state.aiGenerateQuotaTotal = 0;
  }

  updateWindowDimensions() {
    let boundingRect = this.refs.stageViewerBar.refs.div.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + window.scrollY + boundingRect.height + 10);
    this.setState({
      maxHeight: height,
    });
    this.state.maxHeight = height;
  }

  selectStageById(stage_id) {
    let stage = this.getStageDataById(stage_id);
    this.setState({
      selectedStageID: stage_id,
      selectedStage: stage,
    });
    this.state.selectedStageID = stage_id;
    this.state.selectedStage = stage;

    this.refs.stageDetailView.updateStageDetail(stage_id);
    this.refs.editStageDialog.updateStageDetail();
    if (stage != null) {
      if (this.refs.stageDetailView.refs.stageMediaView) {
        this.refs.stageDetailView.refs.stageMediaView.setState({
          playbackTime: 0,
          playbackDuration: parseInt(stage.duration),
          changeFileConfirmed: false,
        });
      }
    }
    if (this.refs.stageDetailView.refs.stageElementListView) {
      this.refs.stageDetailView.refs.stageElementListView.refs.scrollMenu.state.translate = 0;
    }
  }

  getStageDataById(stage_id) {
    for (let i = 0; i < this.state.stageList.length; i++) {
      let stageData = this.state.stageList[i];
      if (stageData['id'] == stage_id) {
        return stageData;
      }
    }
    return null;
  }

  refresh(stage_id) {
    if (stage_id > 0) {
      this.selectStageById(stage_id);
      this.refs.stageListView.selectStage(stage_id);
    }
    else {
      this.refs.stageDetailView.refresh();
    }

    this.refs.stageListView.refresh();
  }

  refreshOK() {
    if (this.state.targetStageData['id'] != null){
      let previous_stage_id = this.state.targetStageData['id'];
      this.setState({
        targetStageData: this.getStageDataById(previous_stage_id),
      });
    }

    let stage = this.getStageDataById(this.state.selectedStageID);
    if (stage) {
      this.setState({
        selectedStage: stage,
      });
      this.state.selectedStage = stage;
    }

    this.refs.editStageDialog.updateStageDetail();
  }

  handleBackButtonClicked() {
    this.props.root.changeStatus(this.props.root.STATUS_VIEW_LOCALE_LIST());
  }

  createNewStage() {
    if (this.props.root.state.canUpload) {
      this.refs.createStageDialog.setState({
        open: true,
        stageName: "",
        stageType: "photo",
      });
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  editStage() {
    this.refs.editStageDialog.setState({
      open: true,
    })
  }

  addStageElement() {
    if (this.props.root.state.canUpload) {
      this.refs.createElementDialog.setState({
        open: true,
      });
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  editStageElement(element) {
    this.refs.editElementDialog.setState({
      open: true,
      playbackData: element,
      activeTab: 0,
    });
  }

  updateStageSetting() {
    if (this.state.selectedStage != null) {
      let requestObj = {
        stage_id: this.state.selectedStage['id'],
        duration: this.refs.editStageDialog.state.stageMinute * 60 + this.refs.editStageDialog.state.stageSecond,
        allow_enter_next_stage: this.refs.editStageDialog.state.allowNextStage,
        panorama_format: this.refs.editStageDialog.state.panoramaFormat,
      }
      this.props.root.refs.API.request("set_stage_settings", requestObj, this.updateStageSettingOK, this.updateStageSettingFailed);
    }
    if (this.state.selectedStage != null) {
      let requestObj = {
        stage_id: this.state.selectedStage['id'],
        stage_name: this.refs.editStageDialog.state.stageName,
      }
      this.props.root.refs.API.request("update_stage_name", requestObj, this.updateStageNameOK, this.updateStageNameFailed);
    }
  }

  updateStageSettingOK(res) {
    this.props.root.addNotification(Localization.strings.UPDATED)
    this.refs.editStageDialog.handleClose();
    this.refresh();
  }

  updateStageSettingFailed(err) {
    console.log("update stage setting failed");
  }

  updateStageNameOK(res) {

  }

  updateStageNameFailed(err) {
    console.log("update stage name failed");
  }

  reuploadFile() {
    this.refs.filePicker.handleChangeClicked();
  }

  uploadFile() {
    if (this.props.root.state.canUpload) {
      //this.refs.filePicker.chooseFile();
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  onUploadSuccess(resp) {
    if (this.state.trashFileIdList.length > 0) {
      for (let i = 0; i < this.state.trashFileIdList.length; i++) {
        if (this.state.trashFileIdList[i] > -1) {
          this.props.root.refs.API.request("mark_file_as_trash", { file_id: this.state.trashFileIdList[i] });
        }
      }
      this.setState({trashFileIdList : []});
    }

    let requestObj = {
      stage_id: this.refs.stageDetailView.state.stageData['id'],
      file_id: resp['file_id'],
    };
    this.props.root.refs.API.request("set_stage_media_file", requestObj, this.setStageMediaOK, this.setStageMediaFailed);
  }

  setStageMediaOK(res) {
    this.refs.stageDetailView.refs.stageMediaView.setState({ changeFileConfirmed: false });
    this.refresh();
  }

  setStageMediaFailed(err) {
    console.log("set stage media failed");
  }

  onChangeFileConfirm() {
    let movieData = this.refs.stageDetailView.state.stageData['movie_list'][0];
    if (movieData != null) {
      this.setState({trashFileIdList: [movieData['file_id']]});
    }
    this.refs.stageDetailView.refs.stageMediaView.setState({ changeFileConfirmed: true });
  }

  onFileDrop(files) {
    if (this.props.root.state.canUpload) {
      this.refs.filePicker.uploadFile(files);
    }
    else {
      this.props.root.showStorageQuotaDialog(this.props.root.emptyFunction);
    }
  }

  render() {
    let allowedExtension = "";
    if (this.state.selectStage) {
      let type = "";
      if (this.state.selectStage['kind'] == 0){
        type = "video";
      }
      else if (this.state.selectStage['kind'] == 1){
        type = "image";
      }
      allowedExtension = Config.GET_ALLOWED_FILE_EXTENSION(type);
    }
    return (
      <div>
        <CreateStageDialog parent={this} root={this.props.root} ref="createStageDialog"/>
        <EditStageDialog parent={this} root={this.props.root} ref="editStageDialog"/>
        <StageViewerBar parent={this} root={this.props.root} ref="stageViewerBar"/>
        <CreateElementDialog parent={this} root={this.props.root} ref="createElementDialog"/>
        <EditElementDialog parent={this} root={this.props.root} ref="editElementDialog"/>
        <StagePicker parent={this} root={this.props.root} ref="stagePicker"/>
        <FilePicker parent={this} root={this.props.root} ref="filePicker"
          localeId={this.props.localeData['id']}
          allowedExtension={allowedExtension}
          onUploadSuccess={this.onUploadSuccess}
          onChangeFileConfirm={this.onChangeFileConfirm}
        />

        <Grid container>
          <Grid item xs={12} sm={3}>
            <StageListView parent={this} root={this.props.root} ref="stageListView"
              locale_id={this.props.localeData['id']}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <StageDetailView parent={this} root={this.props.root} ref="stageDetailView"
              maxHeight={this.state.maxHeight}
              showAIGeneration={true}
              aiGenerateEnabled={this.state.aiGenerateEnabled}
              aiGenerateQuotaTotal={this.state.aiGenerateQuotaTotal}
              localeData={this.props.localeData}
              onUploadSuccess={this.onUploadSuccess}
            />
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default StageViewerPage;
